import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { Bean, FormContextValues } from '@dreryk/react-common';

import {
   EmergencyNotificationSmsConfigurationContactPersonsFieldFormBeanPart,
   EmergencyNotificationSmsConfigurationContactPersonValue,
} from '../EmergencyNotificationSmsConfigurationContactPersonsField.types';

import { useEmergencyNotificationSmsConfigurationContactPersonsInteractiveTableColumnConfigurationOptions } from './EmergencyNotificationSmsConfigurationContactPersonsInteractiveTable.hooks';
import { EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableAddRow } from './EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableAddRow';
import { StyledEmergencyNotificationSmsConfigurationContactPersonsInteractiveTable } from './EmergencyNotificationSmsConfigurationContactPersonsInteractiveTable.styled';
import { EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableSynchronization } from './EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableSynchronization';

type EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableProps = Pick<
   FormContextValues<EmergencyNotificationSmsConfigurationContactPersonsFieldFormBeanPart>,
   'register'
> & {
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationSmsConfigurationContactPersonsInteractiveTable = (
   props: EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableProps
): JSX.Element => {
   const columns = useEmergencyNotificationSmsConfigurationContactPersonsInteractiveTableColumnConfigurationOptions();

   return (
      <StyledEmergencyNotificationSmsConfigurationContactPersonsInteractiveTable<
         EmergencyNotificationSmsConfigurationContactPersonValue,
         Bean
      >
         name={'contactPersons'}
         register={props.register}
         columns={columns}
         testId={'contactPersons'}
      >
         <EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableSynchronization
            emergencyNotificationConfiguration={props.emergencyNotificationConfiguration}
         />
         <EmergencyNotificationSmsConfigurationContactPersonsInteractiveTableAddRow />
      </StyledEmergencyNotificationSmsConfigurationContactPersonsInteractiveTable>
   );
};
